import { AnalyticsReportAgentRunStatus } from "@redotech/cockroachdb-codegen/tables/analytics/analytics-report-agent-run-status";
import * as z from "zod";

export const CustomReportDebugChatMessageSchema = z.object({
  index: z.number(),
  id: z.string().nullable(),
  role: z.enum(["system", "user", "assistant", "tool"]),
  content: z.unknown(),
  usage: z.unknown().nullable(),
});

export const CustomReportDebugChatThreadSchema = z.object({
  threadId: z.string(),
  found: z.boolean(),
  error: z.string().nullable(),
  agentName: z.string().nullable(),
  teamId: z.string().nullable(),
  parentThreadId: z.string().nullable(),
  userDisplayName: z.string().nullable(),
  messageCount: z.number(),
  iterationCount: z.number().nullable(),
  state: z.unknown().nullable(),
  output: z.unknown().nullable(),
  createdAt: z.date().nullable(),
  updatedAt: z.date().nullable(),
  messages: z.array(CustomReportDebugChatMessageSchema),
});

export const CustomReportDebugAgentRunSchema = z.object({
  id: z.string(),
  reportRevisionId: z.string().nullable(),
  threadId: z.string().nullable(),
  parentThreadId: z.string().nullable(),
  toolCallId: z.string().nullable(),
  requestedQuestion: z.string(),
  confirmedPlan: z.string().nullable(),
  status: z.enum(AnalyticsReportAgentRunStatus),
  failureCode: z.string().nullable(),
  progressMessage: z.string().nullable(),
  createdAt: z.date(),
  completedAt: z.date().nullable(),
});

export const CustomReportDebugRevisionSchema = z.object({
  id: z.string(),
  revisionNumber: z.string(),
  queryVersion: z.number(),
  title: z.string().nullable(),
  titleManuallyEdited: z.boolean(),
  sourceAgentRunId: z.string().nullable(),
  createdByUserId: z.string().nullable(),
  createdAt: z.date(),
  semanticQuery: z.unknown(),
  columnPresentation: z.unknown().nullable(),
});
